import { call, put } from 'redux-saga/effects';
import { setIntegrationStatus, setIntegrationLoading } from '../../../state/integration/integrationSlice';
import bugsnagClient from '../../../services/bugsnag/bugsnag';
import { backendClient } from '../../../services/api/backend-client';

export function* fetchCrmStatusSaga(action) {
    const { crm } = action.payload;
    yield put(setIntegrationLoading({ crm, loading: true }));
    try {
        const { data } = yield call(
            [backendClient, backendClient.get],
            `integrations/${crm}/status`
        );
        yield put(setIntegrationStatus({ crm, data }));
    } catch (err) {
        bugsnagClient.notify(err);
        console.error(`Failed to fetch ${crm} status`, err?.response?.status, err?.message);
    } finally {
        yield put(setIntegrationLoading({ crm, loading: false }));
    }
}